import dayjs from "dayjs";
import React from "react";

interface Props {
  endDate: string | null;
  fallback?: React.ReactNode;
  startDate: string | null;
}

class DateRangeComponent extends React.PureComponent<Props> {
  public render() {
    const { endDate, fallback = null, startDate } = this.props;

    return (
      <>
        {!startDate && !endDate ? fallback : null}
        {startDate ? dayjs(startDate).format("YYYY/MM/DD[(]dd[)]") : null}
        {startDate && endDate ? " – " : null}
        {endDate ? dayjs(endDate).format("YYYY/MM/DD[(]dd[)]") : null}
      </>
    );
  }
}

export { DateRangeComponent };
